import { render, staticRenderFns } from "./ValueFormatterEdit.vue?vue&type=template&id=191509a5&scoped=true"
import script from "./ValueFormatterEdit.vue?vue&type=script&lang=js"
export * from "./ValueFormatterEdit.vue?vue&type=script&lang=js"
import style0 from "./ValueFormatterEdit.vue?vue&type=style&index=0&id=191509a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191509a5",
  null
  
)

export default component.exports